<template>
  <v-flex>
    <v-card :color="'rgb(250, 250, 250)'" class="elevation-2">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
          <span v-bind:style="{ color: 'white' }">{{ 'Datos Fiscales de ' + modelProveedor.nombre }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link
          @click="_guardarProveedor(false)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarProveedor(true)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
        </v-chip>
        <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
      </v-toolbar>

      <v-container class="mt-8 px-4 pt-4 pb-4">
        <v-row>
          <v-col>
            <v-row dense class="mx-4">
              <v-text-field v-model="modelProveedor.nombre" outlined label="Nombre" dense :dark="dark"
                autocomplete="off" @input="modelProveedor.nombre = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.cif" :dark="dark" label="Cif" dense
                autocomplete="off" @input="modelProveedor.cif = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.cod_proveedor" :dark="dark" label="Código de Proveedor" dense
                autocomplete="off" @input="modelProveedor.cod_proveedor = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelProveedor.tipo" label="Tipo"
                :items="['Central reservas/op. turístico', 'Mayorista a comisión', 'Acreedor/Gastos']"></v-select>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.email_administracion" :dark="dark"
                label="Email de Administración" dense autocomplete="off"
                @input="modelProveedor.email_administracion = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.telefono_administracion" :dark="dark"
                label="Teléfono de Administración" dense autocomplete="off"
                @input="modelProveedor.telefono_administracion = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.banco_iban" :dark="dark" label="IBAN" dense
                autocomplete="off" @input="modelProveedor.banco_iban = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.swift_bic" :dark="dark" label="SWIFT/BIC" dense
                autocomplete="off" @input="modelProveedor.swift_bic = $event.toUpperCase()"></v-text-field>
            </v-row>
            
            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.direccion_fiscal" :dark="dark" label="Dirección" dense
                autocomplete="off" @input="modelProveedor.direccion_fiscal = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.cod_postal_fiscal" :dark="dark" label="Codigo Postal" dense
                autocomplete="off" @input="modelProveedor.cod_postal_fiscal = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.cod_postal_internacional" :dark="dark"
                label="Codigo Postal Internacional" dense autocomplete="off"
                @input="modelProveedor.cod_postal_internacional = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.poblacion_fiscal" :dark="dark" label="Población" dense
                autocomplete="off" @input="modelProveedor.poblacion_fiscal = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.provincia_fiscal" :dark="dark" label="Provincia" dense
                autocomplete="off" @input="modelProveedor.provincia_fiscal = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.pais_fiscal" :dark="dark" label="País" dense
                autocomplete="off" @input="modelProveedor.pais_fiscal = $event.toUpperCase()"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-combobox outlined dense :dark="dark" autocomplete="off" v-model="modelProveedor.forma_pago"
                label="Forma de Pago" :items="formasPagoItems"></v-combobox>
            </v-row>

            <v-row dense class="mx-4">
              <v-combobox outlined dense :dark="dark" autocomplete="off" v-model="modelProveedor.modalidad_pago"
                label="Modalidad de Pago" :items="modalidadesPagoItems"></v-combobox>
            </v-row>

            <v-row v-if="esModalidadPrepago" dense class="mx-4">
              <v-col cols="8" md="4" class="pa-0 pr-md-2">
                <v-text-field outlined dense :dark="dark" autocomplete="off" v-model.number="modelProveedor.prepago_dias"
                  label="Prepago Días" type="number" min="0"></v-text-field>
              </v-col>
              <v-col cols="16" md="8" class="pa-0 pl-md-2">
                <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelProveedor.prepago_tipo_dias"
                  label="Tipo de Días" :items="prepagoTipoDiasItems"></v-select>
              </v-col>
            </v-row>

          <!--  <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.titulo" :dark="dark" label="Titulo" dense
                autocomplete="off"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined v-model="modelProveedor.mensaje_alerta" :dark="dark" label="Mensaje de Alerta"
                dense autocomplete="off"></v-text-field>
            </v-row>
          -->  

          </v-col>

        </v-row>

      </v-container>

    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "ProveedorFormulario",
  components: {},
  data: () => ({
    loading: false,

    dialogFormularioCalendarioTarifas: false,
    modalidadesPagoItems: [
      "Crédito",
      "Crédito 30 días f/fra.",
      "Crédito máximo día 5 mes siguiente f/fra.",
      "Crédito, grupos 25% 45 días antes, 75% 30 días antes (excepto \"OPERATIVA TODAS AGENCIAS\" 30 días antes 100%)",
      "Pago inmediato",
      "Prepago",
    ],
    formasPagoItems: [
      "DOMICILIACIÓN BANCARIA",
      "DOMICILIACIÓN CUENTA LA CAIXA",
      "Pago en efectivo",
      "Transferencia (PAGOS 1494)",
      "Tarjeta de Credito MIGUEL 6029",
      "TARJETA CRÉDITO LA CAIXA ANDRÉS",
    ],
    prepagoTipoDiasItems: ["Naturales", "Laborables"],


  }),

  props: {
    modelProveedor: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "tiposProveedor",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("proveedores", [
      "regimenes",
      "categoriasProveedor",
      "tiposHabitacion",
      "caracteristicasHabitacion",
      "puntosProveedores",
    ]),
    esModalidadPrepago() {
      return this._esModalidadPrepago();
    },



  },

  watch: {
    "modelProveedor.modalidad_pago"(newVal) {
      if (!this._esModalidadPrepago(newVal)) {
        this.modelProveedor.prepago_dias = null;
        this.modelProveedor.prepago_tipo_dias = null;
      }
    },
  },

  mounted() {
    this._inicializarCamposProveedorFiscal();
  },

  methods: {
    ...mapActions("proveedores", ["getProveedores", "crearProveedor", "updateProveedorDatosFiscales"]),
    ...mapActions("puntos", ["getPuntos"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioDatosFiscales");
    },

    _openGestionCalendarioTarifas() {

      this.dialogFormularioCalendarioTarifas = true;
    },

    _esModalidadPrepago(modalidadPago = this.modelProveedor.modalidad_pago) {
      if (!modalidadPago) {
        return false;
      }
      return String(modalidadPago).trim().toLowerCase() === "prepago";
    },

    _normalizarBoolean(value) {
      if (value === 1 || value === "1") {
        return true;
      }

      if (value === 0 || value === "0") {
        return false;
      }

      return !!value;
    },

    _inicializarCamposProveedorFiscal() {
      const defaults = {
        deshabilitado: false,
        comisiones_iva_incluido: false,
        retener_irpf: false,
      };

      Object.entries(defaults).forEach(([field, defaultValue]) => {
        if (!Object.prototype.hasOwnProperty.call(this.modelProveedor, field)) {
          this.$set(this.modelProveedor, field, defaultValue);
        }
      });

      this.modelProveedor.deshabilitado = this._normalizarBoolean(this.modelProveedor.deshabilitado);
      this.modelProveedor.comisiones_iva_incluido = this._normalizarBoolean(this.modelProveedor.comisiones_iva_incluido);
      this.modelProveedor.retener_irpf = this._normalizarBoolean(this.modelProveedor.retener_irpf);
    },

    async _guardarProveedor(cierre) {
      this.loading = true;
      this._inicializarCamposProveedorFiscal();
      if (this._esModalidadPrepago()) {
        const prepagoDias = parseInt(this.modelProveedor.prepago_dias, 10);
        this.modelProveedor.prepago_dias = Number.isNaN(prepagoDias) ? null : prepagoDias;
        if (!this.prepagoTipoDiasItems.includes(this.modelProveedor.prepago_tipo_dias)) {
          this.modelProveedor.prepago_tipo_dias = null;
        }
      } else {
        this.modelProveedor.prepago_dias = null;
        this.modelProveedor.prepago_tipo_dias = null;
      }
      if (this.accion == "editar") {
        const payload = {
          ...this.modelProveedor,
          deshabilitado: this.modelProveedor.deshabilitado ? 1 : 0,
          comisiones_iva_incluido: this.modelProveedor.comisiones_iva_incluido ? 1 : 0,
          retener_irpf: this.modelProveedor.retener_irpf ? 1 : 0,
        };
        var res = await this.updateProveedorDatosFiscales([
          this.access_token,
          payload,
        ]);
        if (cierre) {
          this._cerrarVentana();
        }
      }
      this.loading = false;
    },
  },
};
</script>
